import { ArticleItem } from 'types'

export const quarantineGamesTextEn: Array<ArticleItem> = [
  {
    text: '',
    style: ['space'],
  },
  {
    text: 'Author: Marta Macedo Brietzke',
    style: ['paragraph', 'margin'],
  },
  {
    text: '',
    style: ['space'],
  },
  {
    text: `The games described below were created in 2020 based on the games used in my master's study. At the time they were thought of, the world was experiencing the first two waves of the COVID-19 pandemic, when contact and physical presence became difficult due to sanitary and epidemiological conditions. The intention of these activities is to maintain some of the possible aspects of collective teaching of musical instruments, even at a distance, with the help of digital technologies. For its application, I suggest each teacher to create, with students, a virtual exchange environment, such as a message group, in which students share their creations, experiences and discoveries, for example. I hope that the world does not have to go through new phases of isolation and that these activities can be used in other moments of distance or face-to-face teaching and learning.`,
    style: ['paragraph', 'italic'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '1. Sound detective',
    style: ['title2', 'anchor'],
  },
  {
    text: `Each student must add to an inventory at least five sounds that began to be part of their daily lives during quarantine. Add sounds that happen inside the house, sounds that come from neighbors, from windows, from the streets. Record the inventoried sounds in audio or video. Choose three sounds and create a way to play them on your instrument. It doesn't have to be a literal reproduction, but it must make sense to whoever created it. Record the three sounds created with the cello. Send the created sounds to a colleague. Each student is tasked with discovering which original sound inspired their colleague. While the student who received the recording does not discover what the original sound is, who created it sends "clues" until the colleague identifies it. In advance, establish how much time will be allocated for discovering the sound of the colleague, before sending a new track, and so on.`,
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '2. What sound is this?',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Each student must send the original recording of one of their inventoried sounds to a colleague. Those who received and who sent the sound must create with their instruments, individually, their versions to represent that sound. Later, collectively listen to the two sounds created by the two students. Observe and talk about differences and similarities. A collective representation for the original sound can also be created after the considerations that emerged in this conversation.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '3. Virtual sound cordless phone',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'A student (student 1) must record a short snippet of some of their creations on their instrument. It can be a rhythmic or melodic cell, or expanded sonorities etc. Then send it to a colleague (student 2). The colleague can only listen to the received passage three times. Then record your version of the excerpt and send it to another colleague (student 3). This continues the activity until the whole class has participated. At the end, the recordings are heard collectively in the sequence (1, 2, 3, 4...). The class should talk about what happened in the process, if there were changes, how they happened, if the recordings are similar, etc.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '4. Musical LEGO',
    style: ['title2', 'anchor'],
  },
  {
    text: `A student (student 1) must record a short snippet of some of their creations on their instrument. As in the previous game, it can be a rhythmic or melodic cell, or expanded sonorities etc. Send to a colleague (student 2). Whoever received the recording can listen as many times as they wish and try to reproduce the same passage with their instrument. Your version does not have to be exactly the same, but it should be similar to the recording received. Student 2 must create one more snippet and add this snippet to his colleague's creation. Record the two excerpts in sequence (excerpt 1, excerpt 2) and send to another colleague (student 3). The student who received the recording must do the same process, continue the creation, and send a recording of the 3 excerpts in sequence (excerpt 1, excerpt 2, excerpt 3) to another colleague. The activity must continue successively until it returns to the first student (Student 1), who must reproduce the entire creation. Everyone collectively listens to the final version and talks about what they heard, putting their perceptions, ideas etc.`,
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '5. Window stories',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Each student must record the sounds from their window or backyard for about three minutes at three times of the day: morning, afternoon, and night. Recordings must always be carried out in the same location. Each student must listen to the three recordings and see if there are differences or similarities between the sounds, such as intensities, timbres, colors, movements etc. Each one must create, with their instrument, a musical story, with a beginning, middle, and end, that tells something about these three different or similar sound moments of the day. Then, each student must record their musical story and send it to a colleague. The student who received the recording must listen carefully to the musical story of his colleague and create a short text, written or oral, that tells what he imagined with the musical story received.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '6. Writing the story',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'This game is a continuation of game 5. The student who received the story recorded by his colleague must build, in his own way, a “score” or graphic representation, in which he or she recorded the way of registering the sound story received.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '7. Mirror, mirror on the wall',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Each student must choose three sounds recorded with their instrument and send them to a colleague. This colleague (student 2) must create a score or graphic representation for the sound received in the recording. Then, send the created score to a third colleague (student 3) who must, with its instrument, interpret the score in its own way. Then everyone listens to the sound recorded by student 1 and then the version of student 3. Together they observe and talk about similarities and differences. They can also collectively create a new interpretation or a new score.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '8. Musical map',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'The class must collectively create a virtual map of sounds. This map, depending on each class, can be the map of the country, state, city, neighborhood or street. Initially, make a map through a photo, an image or a drawing, as chosen by everyone. Put this map on a digital platform, where it can be viewed by the whole class. Each person must record, with their instrument, at least three small videos or audios with sounds that represent the place where they live. These sounds can be sounds from the house or surroundings. The teacher receives these videos or audios, creates a link on some social media and attaches the link to the map, in the place where that person lives. Make the map with the linked videos or audios available to everyone in the class. Reserve one or more moments in which the class can watch the videos collectively, establishing the dialogues that can arise from this experience.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '9. Sounds that say “I miss you”',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Each student searches on his instrument for some sounds that represent, for him or her, places, things, people, situations, experiences, which he or she misses for not being present, or being experienced, due to physical distance. In a collective meeting, each person in the class shows with their instrument, or with a recording made in advance, the chosen sound. Then, the student shares with colleagues a little about the chosen sound and what it represents.',
    style: ['paragraph'],
  },
  {
    text: '',
    style: ['line'],
  },
  {
    text: '10. Our quarantine song',
    style: ['title2', 'anchor'],
  },
  {
    text:
      'Collectively, the class must create a song that encompasses all the sounds chosen in activity 9. The class must decide whether to tell a collective story with these sounds or if the music will not be descriptive, how the sounds will be organized, if they will sound simultaneously or in sequence. In addition to musical choices, the dexterity and technological possibilities available to each class must also be taken into account. Each student must record a short video on their instrument performing the sound chosen by them. One or more people assemble a video or audio with the music created according to the guidelines of the class and then present it for everyone to hear collectively. This process can take as many classes as necessary, as the combinations made can be evaluated and, consequently, changed, until the class reaches a consensus on the final proposal. Afterwards, the class can collectively write a score or graphic representation of the music created.',
    style: ['paragraph'],
  },
]
